import { useQuery } from "@tanstack/react-query";
import { getMerchantTeamsRoles } from "@/services/role-access.service";

export const useMerchantTeamRoles = (enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["merchant-team-roles"],
    queryFn: getMerchantTeamsRoles,
    enabled,
    ...options,
  });
};
